module.exports = __webpack_public_path__ + "bb1.no1.9700b379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bb1.no1.jpg
// module id = l4Vo
// module chunks = 0